module.exports = __webpack_public_path__ + "assets/img/btn-view-info-49e9174b.png";